const runtimeOrigin = typeof window !== 'undefined' ? window.location.origin : 'https://novafito.novatellus-local.com';
const runtimeHost = typeof window !== 'undefined' ? window.location.hostname : 'novatellus-local.com';

/** In locale (proxy su *.novatellus-local.com) i cookie stanno su quel dominio, qualunque sia il Keycloak. */
export const isLocalHost = runtimeHost.endsWith('novatellus-local.com');

/** Dominio dei cookie di login dell'ambiente remoto, o quello locale. */
export function cookieHost(remoteHost: string): string {
  return isLocalHost ? 'novatellus-local.com' : remoteHost;
}

/**
 * Login con @arpes-is/angular-20-auth, come nel QdC (libs/shared-local/apps-config/.../environments):
 * dalla 1.1.0 token e sessione stanno nel sessionStorage dell'app (`<cookiePrefix><nome>`), non più nei
 * cookie di dominio; la sessione condivisa con le altre app è quella SSO di Keycloak. Nei cookie del
 * dominio `.host` restano tema e lingua. Prefisso e dominio diversi per ambiente evitano che dev
 * sovrascriva prod (`.dev.novatellus.com` + `dev_`, `.novatellus.com` senza prefisso).
 *
 * Novafito ospita le proprie pagine /login, /auth/check e /silent-refresh.html: `baseUrl` è l'host
 * che serve l'app, quindi `<origine>/auth/check` e `<origine>/silent-refresh.html` devono essere tra i
 * redirect URI del client Keycloak.
 */
export const baseEnvironment = {
  shared: {
    type: 'development',
    api: {
      novakb: {
        url: 'https://api.crm.dev.novatellus.com/api/v1',
      },
      oidc: {
        url: 'https://auth.dev.novatellus.com',
      },
      withoutAuth: [] as string[],
      withoutSessionCheck: [] as string[],
    },
    appRealm: '/realms/novatellus',
    authClientId: 'qdc-oauth2',
    baseUrl: runtimeOrigin,
    appEntryPoint: `${runtimeOrigin}/search`,
    host: cookieHost('dev.novatellus.com'),
    // Locale e dev usano il Keycloak di dev: stesso prefisso del QdC (dev.ts e development.ts)
    cookiePrefix: 'dev_',
    auth: {
      errorPath: '/login',
      // Authorization Code + PKCE con refresh token: da attivare quando il client qdc-oauth2 sarà pubblico.
      // Con false resta il flusso implicito con rinnovo nell'iframe (/silent-refresh.html).
      codeFlow: false,
    },
  },
};
